import { render } from "./AposTag.vue?vue&type=template&id=4b39e1ac&scoped=true"
import script from "./AposTag.vue?vue&type=script&lang=js"
export * from "./AposTag.vue?vue&type=script&lang=js"

import "./AposTag.vue?vue&type=style&index=0&id=4b39e1ac&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b39e1ac"],['__file',"ui/ui/apos/components/AposTag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b39e1ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b39e1ac', __exports__)) {
    api.reload('4b39e1ac', __exports__)
  }
  
  module.hot.accept("./AposTag.vue?vue&type=template&id=4b39e1ac&scoped=true", () => {
    api.rerender('4b39e1ac', render)
  })

}


export default __exports__